import React from 'react';
import PropTypes from 'prop-types';
import BonusRunCreditsEntry from './BonusRunCreditsEntry';
import styles from './BonusRunCredits.module.scss';

function BonusRunCreditsTable({ runCredits, isEditable = false }) {
  return (
    <table className={styles.creditTable}>
      <thead>
        <tr>
          <th>User</th>
          <th>Credit Type</th>
          <th style={{ textAlign: 'center' }}>Base Count</th>
          <th style={{ textAlign: 'center' }}>Credits</th>
          <th style={{ textAlign: 'center' }}>Runs Used</th>
          <th style={{ textAlign: 'center' }}>Runs Left</th>
          <th style={{ textAlign: 'center' }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(runCredits) && runCredits.length > 0 ? (
          runCredits.map(rc => (
            <BonusRunCreditsEntry
              key={rc.creditId}
              runCredit={rc}
              isEditable={isEditable}
            />
          ))
        ) : (
          <tr>
            <td colSpan={7} className={styles.emptyRow}>
              No users available for Bonus Report credits.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

BonusRunCreditsTable.propTypes = {
  runCredits: PropTypes.arrayOf(PropTypes.object).isRequired,
  isEditable: PropTypes.bool
};

export default BonusRunCreditsTable;